import { Component, Output, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { slideInFromBottomAnimation } from '../scss/slide-in-from-bottom-animation';

@Component({
  selector: 'app-email-control-panel',
  templateUrl: './email-control-panel.component.html',
  animations: [slideInFromBottomAnimation],
  encapsulation: ViewEncapsulation.None
})
export class EmailControlPanelComponent {
  @Input()
  showDiscussionButton: boolean;

  @Input()
  isDiscussionButtonDisabled: boolean;

  @Input()
  hasWrapUps: boolean;

  @Output()
  reply: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  replyAll: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  forward: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  discuss: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  close: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  transfer: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  wrapUp: EventEmitter<any> = new EventEmitter<any>();

  public onReplyClick(): void {
    this.reply.emit();
  }

  public onReplyAllClick(): void {
    this.replyAll.emit();
  }

  public onForwardClick(): void {
    this.forward.emit();
  }

  public onDiscussionsClick(): void {
    this.discuss.emit();
  }

  public onCloseClick(): void {
    this.close.emit();
  }

  public onTransferClick(): void {
    this.transfer.emit();
  }

  public onWrapUpClick(): void {
    this.wrapUp.emit();
  }
}
